// @copyright  2006 - 2024 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'issued-loan-collateral.page.title': 'Loan Collaterals',
    'issued-loan-collateral.page.archive.title': 'Archived Collaterals',
    'issued-loan-collateral.page.search_results': 'Search Results',
    'issued-loan-collateral.page.create.title': 'Create New Collateral',
    'issued-loan-collateral.page.search.title': 'Find Collaterals',
    'issued-loan-collateral.page.edit.title': 'Edit Collateral',
    'issued-loan-collateral.page.view.title': 'View Collateral',
    'issued-loan-collateral.page.all': 'All',

    'issued-loan-collateral.button.cancel': 'Cancel',
    'issued-loan-collateral.button.select': 'Select',
    'issued-loan-collateral.button.find': 'Find Collaterals',
    'issued-loan-collateral.button.search': 'Apply',
    'issued-loan-collateral.button.create': 'Create Collateral',
    'issued-loan-collateral.button.new': 'New Collateral',
    'issued-loan-collateral.button.save': 'Save Changes',
    'issued-loan-collateral.button.archive': 'Archive',
    'issued-loan-collateral.button.delete': 'Permanently Delete',
    'issued-loan-collateral.button.edit': 'Edit',
    'issued-loan-collateral.button.restore': 'Restore',
    'issued-loan-collateral.button.reset': 'Reset',

    'issued-loan-collateral.placeholder.search': 'Search loan collaterals',

    'issued-loan-collateral.link.create_first_issued_loan_collateral': 'Click here to create your first loan collateral',
    'issued-loan-collateral.link.issued_loan_collaterals': ' Return to Collaterals',
    'issued-loan-collateral.link.archive': 'Archived  Collaterals',
    'issued-loan-collateral.link.retry': 'Click here to retry',

    'issued-loan-collateral.checkbox.all': 'Check All',
    'issued-loan-collateral.checkbox.actions_label': 'with selected',

    'issued-loan-collateral.label.issued_loan_name': 'Issued Loan',
    'issued-loan-collateral.label.description': 'Description',
    'issued-loan-collateral.label.currency_name': 'Currency',
    'issued-loan-collateral.label.currency_collateral_value_in_cents': 'Collateral Value',
    'issued-loan-collateral.label.valued_at': 'Value As At',

    'issued-loan-collateral.sort.field_label': 'Field',
    'issued-loan-collateral.sort.direction_label': 'Direction',
    'issued-loan-collateral.sort.direction_ascending': 'Ascending',
    'issued-loan-collateral.sort.direction_descending': 'Descending',

    'issued-loan-collateral.modal.title.issued_loan_collateral_archive': 'Archive Collateral',
    'issued-loan-collateral.modal.title.issued_loan_collateral_restore': 'Restore Issued Loan Collateral',

    'issued-loan-collateral.modal.message.issued_loan_collateral_archive': 'Are you sure that you want to move this collateral to the archive? | Are you sure that you want to move these collaterals to the archive?',
    'issued-loan-collateral.modal.message.issued_loan_collateral_delete_permanently':
        'Are you sure that you want to permanently delete this collateral? This action cannot be undone. | Are you sure that you want to permanently delete these collaterals? This action cannot be undone.',
    'issued-loan-collateral.modal.message.issued_loan_collateral_restore': 'Are you sure that you want to restore this collateral? | Are you sure that you want to restore these collaterals?',

    'issued-loan-collateral.success.message.issued_loan_collateral_created': 'Your collateral has been created',
    'issued-loan-collateral.success.message.issued_loan_collateral_updated': 'Your collateral has been updated',
    'issued-loan-collateral.success.message.issued_loan_collateral_restored': 'Your collateral has been restored | All selected collaterals were restored',
    'issued-loan-collateral.success.message.issued_loan_collateral_deleted': 'Your collateral has been permanently deleted | All selected collaterals were permanently deleted',
    'issued-loan-collateral.success.message.archived_issued_loan_collaterals': 'Your collateral was moved to the archive | All selected collaterals were moved to the archive',

    'issued-loan-collateral.error.message.archived_issued_loan_collaterals': 'This collateral was already moved to the archive | These collaterals were already moved to the archive',
    'issued-loan-collateral.error.message.issued_loan_collateral_deleted': 'This collateral was already permanently deleted | These collaterals were already permanently deleted',
    'issued-loan-collateral.error.message.issued_loan_collateral_restored': 'This collateral was already restored | These collaterals were already restored',
    'issued-loan-collateral.error.message.error_loading_page': 'Sorry, there was an error loading collateral.| Sorry, there was an error loading collaterals.',

    'issued-loan-collateral.message.search.no_archived_issued_loan_collaterals': "You don't have any archived collaterals.",
};
